import React from 'react';

import { CampaignType } from 'src/actions/campaigns/campaignsResource';
import RecipientCollections from 'src/presentation/components/pages/proactiveCommunications/components/shared/RecipientCollections';
import AddVoiceRecipientsForm from './AddVoiceRecipientsForm';
import VoiceCampaignContentDetails from './VoiceCampaignContentDetails';

const VoiceRecipientCollections = ({ root }) => (
  <RecipientCollections
    addRecipientFormComponent={AddVoiceRecipientsForm}
    backButtonLabel="Proactive Voice"
    campaignContentDetailsComponent={VoiceCampaignContentDetails}
    campaignType={CampaignType.VOICE}
    root={root}
  />
);

export default VoiceRecipientCollections;
